import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Mail, Facebook } from 'lucide-react';
import { businessInfo } from '../mock';

export const Header = () => {
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path;
  
  return (
    <header className="bg-white shadow-lg border-b-4 border-red-600">
      {/* Top contact bar */}
      <div className="bg-black text-white py-2">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center space-x-6">
            <div className="flex items-center space-x-2">
              <Phone className="w-4 h-4 text-red-500" />
              <span>{businessInfo.phone}</span>
            </div>
            <div className="flex items-center space-x-2">
              <Mail className="w-4 h-4 text-red-500" />
              <span>{businessInfo.email}</span>
            </div>
          </div>
          <div className="text-red-500 font-medium">
            {businessInfo.qualification}
          </div>
        </div>
      </div>
      
      {/* Main header */}
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Facebook Link */}
          <a 
            href="https://www.facebook.com/DriveInverclyde"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-3 text-gray-700 hover:text-red-600 transition-colors group"
          >
            <div className="bg-blue-600 hover:bg-blue-700 text-white p-2 rounded-full shadow-md group-hover:shadow-lg transition-all">
              <Facebook className="w-5 h-5" />
            </div>
            <span className="font-medium hidden sm:inline">Follow us on Facebook</span>
          </a>
          
          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`font-medium transition-colors hover:text-red-600 ${
                isActive('/') ? 'text-red-600 border-b-2 border-red-600 pb-1' : 'text-gray-700'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/services" 
              className={`font-medium transition-colors hover:text-red-600 ${
                isActive('/services') ? 'text-red-600 border-b-2 border-red-600 pb-1' : 'text-gray-700'
              }`}
            >
              Services
            </Link>
            <Link 
              to="/about" 
              className={`font-medium transition-colors hover:text-red-600 ${
                isActive('/about') ? 'text-red-600 border-b-2 border-red-600 pb-1' : 'text-gray-700'
              }`}
            >
              About
            </Link>
            <Link 
              to="/contact" 
              className={`font-medium transition-colors hover:text-red-600 ${
                isActive('/contact') ? 'text-red-600 border-b-2 border-red-600 pb-1' : 'text-gray-700'
              }`}
            >
              Contact
            </Link>
            <Link 
              to="/terms" 
              className={`font-medium transition-colors hover:text-red-600 ${
                isActive('/terms') ? 'text-red-600 border-b-2 border-red-600 pb-1' : 'text-gray-700'
              }`}
            >
              Terms
            </Link>
          </nav>
          
          {/* CTA Button */}
          <Link 
            to="/contact"
            className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors shadow-lg hover:shadow-xl"
          >
            Book Lesson
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;